const filterFeatureCollectionByParentIdNoZoom = (fc, parentId) =>
  fc?.features
    ? fc.features.map(feat => {
        const newLayer =
          parentId === feat.properties?.id ||
          (parentId === feat.properties?.propertyId &&
            !feat.properties?.$parentDuplicated)
            ? 'selected'
            : 'default';
        if (feat.properties?.$layer === newLayer) return feat;
        return {
          ...feat,
          properties: { ...feat.properties, $layer: newLayer }
        };
      })
    : [];

export default filterFeatureCollectionByParentIdNoZoom;
